import saveManager from '../utils/SaveManager';

const recordedSoundUploadingUtils = {
    isUploadingCurrentSound: false,
    currentContentItemId: -1,
    currentTile: '',
    refreshTimer: -1,

    startStoring() {
        this.isUploadingCurrentSound = true;
        saveManager.isContentChanged(true);
    },
    stopStoring() {
        this.isUploadingCurrentSound = false;

        setTimeout(function() {
            saveManager.saveContent(true);
        }.bind(this), 500);
    },
    isContentChanged() {
        if (this.isUploadingCurrentSound)
            return true;

        return saveManager.contentChanged;
    }
};

export default recordedSoundUploadingUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/RecordedSoundUploadingUtils.js
 **/